export class PickupPointGroup {
  id: number;
  name: string;

  constructor(
    id: number,
    name: string,
  ) {
    this.id = id;
    this.name = name;
  }

  static createFromAny(object: any): PickupPointGroup {
    if (object === null || object === undefined) {
      return null;
    }

    return new PickupPointGroup(
      +object.id,
      object.name,
    );
  }

}
